import { useMemo } from 'react';
import { PinnableItem, usePinnedOrder } from './usePinnedOrder';

// Floats selected items to the top; recomputes only on open and on search-clear, not every toggle.
export function usePinnedRefinementItems<T extends PinnableItem>(
    items: T[],
    searchText: string,
    isOpen: boolean,
): T[] {
    const pinnedOrder = usePinnedOrder(items, searchText, isOpen);

    return useMemo(() => {
        if (searchText || !pinnedOrder.length) return items;

        const pinnedSet = new Set(pinnedOrder);
        const pinned = pinnedOrder
            .map((value) => items.find((item) => item.value === value))
            .filter((item): item is T => !!item);
        const rest = items.filter((item) => !pinnedSet.has(item.value));

        return [...pinned, ...rest];
    }, [items, searchText, pinnedOrder]);
}
